// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
   width: 40%;
   height: 150px;
   padding: 12px 20px;
   box-sizing: border-box;
   border: 2px solid #ccc;
   border-radius: 4px;
   background-color: #f8f8f8;
   font-size: 16px;
   resize: none;
}

label[for='mat-input-2'] {
   padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/mail-flow/message-recipients/message-recipients.component.css"],"names":[],"mappings":"AAAA;GACG,UAAU;GACV,aAAa;GACb,kBAAkB;GAClB,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;GACzB,eAAe;GACf,YAAY;AACf;;AAEA;GACG,aAAa;AAChB","sourcesContent":["textarea {\n   width: 40%;\n   height: 150px;\n   padding: 12px 20px;\n   box-sizing: border-box;\n   border: 2px solid #ccc;\n   border-radius: 4px;\n   background-color: #f8f8f8;\n   font-size: 16px;\n   resize: none;\n}\n\nlabel[for='mat-input-2'] {\n   padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
